// extracted by mini-css-extract-plugin
export default {"formLabel":"Form_formLabel__alHO0","formInput":"Form_formInput__sgOCo","submitBtn":"Form_submitBtn__eUc-v"};